import {
  MultiCurrencyPrice,
} from '@dapi/sdk';
import {
  createMultiCurrencyPriceFromPrice,
} from '@dapi/sdk/helpers';
import {
  createPrice,
  MockPrice,
} from '@dapi/sdk/spec';
import {
  currencyCode,
} from './currency';
import {
  taxes,
} from './tax';

export const price: MockPrice = createPrice({
  template: {
    base: 435,
    currencyCode: currencyCode,
    currency: {
      name: 'EURO',
      decimalPlaces: 2
    },
    taxes: taxes,
    total: 435,
    totalTaxes: 2541
  }
});


export const multiCurrencyPrice: MultiCurrencyPrice = createMultiCurrencyPriceFromPrice(price);

export const totalPrice: MultiCurrencyPrice = {
  base: {
    value: 435,
    currencyCode: currencyCode,
    currency: {
      name: 'Euro',
      decimalPlaces: 2
    }
  },
  total: {
    value: 435,
    currencyCode: currencyCode,
    currency: {
      name: 'Euro',
      decimalPlaces: 2
    }
  }
};

